export const AlYuserApiUrls = {
  accountController: {
    getAccountsByMainAccountType: "/Accounts/GetAccountsByMainAccountType",
    getAllMainAccountType: "/Accounts/GetAllMainAccountType",
    getCurrentAccountBalance: "GetCurrenctAccountBalance",
    getAllBoxAccounts: "Accounts/GetAllBoxAccount",
    getAllAccounts: "GetAllAccounts",
    getAccountInfoById: "GetAccountInfoById",
    searchRuleReceiveMoneyAccounts: "SearchRuleReceiveMoneyAccounts",
    searchAccounts: "SearchAccounts",
    SearchAccountsSample: "Account/SearchAccountsSample",
    getAccountsToBindByAcTransactionType:
      "Accounts/GetAccountsToBindByAcTransactionType",
    getInOutAccountsForPayments: "Accounts/GetInOutAccountsForPayments",
    searchRuleExpenseMoneyAccounts: "SearchRuleExpenseMoneyAccounts",
    saveAccount: "Account/SaveAccount",
    deleteAccount: "DeleteAccount",
    saveRuleExpenseMoney: "SaveRuleExpenseMoney",
    saveRuleReceiveMoney: "SaveRuleReceiveMoney",
  },
  acTransactionReportController: {
    searchReportGeneralLedger: "AcReport/GeneralLedgerReport",
    searchReportIncomeStatement: "AcReport/IncomeStatmentReport",
    searchReportBalanceSheet: "AcReport/BalanceSheetReport",
    searchReportTrialBalance: "AcReport/TrialBalanceReport",
    reportUserAcTransactionLog: "AcReport/ReportUserAcTransactionLog",
    reportUserTransactionLogs: "TransactionsReport/ReportLogUserTransaction",
  },
  acTransactionController: {
    getAcTransactionBeginBalanceList:
      "AcTrasnaction/GetAcTrasnactionDetailBeginBalance",
    searchAcTransactionTreasury: "SearchAcTransactionTreasury",
    selectAcTransaction: "GetAcTrnsactionByID",
    searchAccountTransaction: "/AcTrasnaction/SearcAcTransactions",
    getAcTransactionFullDetailById:
      "AcTrasnaction/GetAcTransactionFullDetailById",
    getAcDailyBoxDetailsById: "AcTrasnaction/GetAcDailyBoxFullDetailById",
    printAcJurnalVoucher: "AcTrasnaction/PrintAcJurnalVoucher",
    printAcDailyBox: "AcTrasnaction/PrintAcDailyBox",
    printAcTransactionTreasury: "PrintAcTransactionTreasury",
    saveBeginBalanceAcTransaction: "AcTrasnaction/SaveSimpleAcTransaction",
    deleteAcTransaction: "DeleteAcTransaction",
    saveCurrentVoucher: "/AcTrasnaction/SaveJurnalVoucher",
    saveCurrentDailyBox: "/AcTrasnaction/SaveDailyBox",
  },
  alertReportController: {
    getReportOfUserAlert: "AlertReport/GetReportOfUserAlert",
  },
  branchController: {
    getAllBranches: "Branche/GetAllBranches",
    getBranchById: "Branch/GetBranchById",
    saveBranch: "Branch/SaveBranch",
    deleteBranch: "Branch/deleteBranch",
  },
  calcTypeController: {
    getAllCalcTypes: "CalcType/GetAllCalacType",
    getCalcTypeById: "CalcType/GetCalcTypeById",
    saveCalcType: "CalcType/SaveCalcType",
    deleteCalcType: "CalcType/DeleteCalcType",
  },
  categoryController: {
    getCategoryList: "GetCategoryList",
    GetCategoryById: "Category/GetCategoryById",
    getCategoryImageById: "Category/GetCategoryImageById",
    getCategoryForPos: "Category/GetCategoryForPos",
    saveCategory: "SaveCategory",
    deleteCategory: "DeleteCategory",
  },
  commonController: {
    getControlsSettings: "GetControlsSettings",
    saveGvColumnControlSettingList:
      "GvColumnsControlSetting/SaveGvColumnControlSettingList",
  },
  companySettingController: {
    getCompanySetting: "getCompanySettings",
    getActiveVouchersSettings: "GetActiveVouchersSettings",
    getEgyptInvoiceSettings: "GetEgypteInvoiceSettings",
    saveCompanySetting: "SaveCompanySetting",
    saveVoucherSettings: "SaveVoucherSettings",
    saveEgyptInvoiceSettings: "SaveEgypteInvoiceSettings",
  },
  configurationController: {
    getAllClientConfiguration: "Configurations/GetAllClientConfiguration",
  },
  einvoiceTransactionController: {
    searchEinvoiceTransactions: "EinvoiceTransaction/SearchEinvoiceTransaction",
    reUploadEinvoiceTransactions: "/EinvoiceTransaction/UploadToEinvoiceProtal",
  },
  customerController: {
    searchCustomerLight: "Customers/SearchCustomLight",
    searchCustomer: "SearchCustomer",
    getCustomerInvoiceType: "GetCustomerInvoiceType",
    getAllCustomers: "GetAllCustomers",
    getAllSuppliers: "GetAllSuppliers",
    deleteCustomer: "DeleteCustomer",
    saveCustomer: "SaveCustomer",
    getCurrentBalanceByCustomerId: "Customer/GetCurrenctBalanceByCustomerId",
  },
  customerReportController: {
    reportDebitCustomer: "CustomerReport/ReportDebitCustomer",
    reportDebitSupplier: "CustomerReport/ReportDebitSupplier",
    reportCustomersTransactionAndAcTransaction:
      "CustomerReport/ReportCustomersTransactionAndAcTransaqction",
    reportSuppliersTransactionAndAcTransaction:
      "CustomerReport/ReportSuppliersTransactionAndAcTransaqction",
    reportCustomersData: "CustomerReport/ReportCustomersData",
    reportCustomerPayments: "CustomerReport/ReportCustomerPayments",
    reportCustomersAccount: "CustomerReport/ReportCustomersAccount",
    reportAllCustomersTransaction:
      "CustomerReport/ReportAllCustomersTransaction",
  },
  currencyController: {
    getCurrencyList: "GetCurrencyList",
    getCurrencyById: "GetCurrencyById",
    getCurrenciesShortCut: "GetCurrenciesShourtCut",
    saveCurrency: "SaveCurrency",
    deleteCurrency: "DeleteCurrency",
  },
  closeDayController: {
    searchStation: "Stations/SearchStation",
    closeDayOfStation: "Stations/CloseDayOfStation",
    printCloseDay: "Station/PrintCloseDay",
  },
  dictionaryController: {
    getAllDictionaryList: "GetAllDictionaryList",
    getButtonDictionaryList: "GetButtonDictionaryList",
    saveNotExistTranslation: "SaveNotExistTranslation",
    saveDictionaries: "SaveDictionaries",
  },
  employeeController: {
    getAllEmployees: "GetAllEmployees",
    getEmployeeInformation: "GetEmployeeById",
    getEmployeeCommissionPerCategory:
      "Employee/GetEmployeeCommissionPerCategory",
  },
  employeeEstihkakSubtractController: {
    getAllEsthkakSubtractByRuleTypeId: "GetAllEsthkakSubtractByRuleTypeId",
    getEstihkakSubtractRuleById: "GetEstihkakSubtractRuleById",
    GetEstihkakSubtractById: "GetEstihkakSubtractById",
    searchEstihkakSubtract: "SearchEstihkakSubtract",
    saveEstihkakSubtractRule: "SaveEstihkakSubtractRule",
    deleteEstihkakSubtractRule: "DeleteEstihkakSubtractRule",
  },
  employeeReportController: {
    reportEmployeeEsthkakSubtracts:
      "EmployeeReport/ReportEmployeeEsthkakSubtracts",
    reportEmployeeSalesComission:
      "EmployeeReport/ReportEmployeeSalesCommission",

    reportEmployeeCashierSales: "EmployeeReport/ReportEmployeeCashierSales",
  },
  entityUploadedDocumentController: {
    saveUploadedDocument: "EntityUploadedDocument/SaveUploadedDocument",
    GetEntityUploadedDocumentByTypeId:
      "EntityUploadedDocument/GetEntityUploadedDocumentByTypeId",
  },
  installmentPlanController: {
    getInstallmentsPlanDetails: "InstallmentPlan/DistributeInstallmentPlan",
    saveInstallmentPlan: "InstallmentPlan/SaveInstallmentPlan",
    getInstallmentsPlansByCustomerId:
      "InstallmentPlane/GetAllInstallmentPlanByCustomerId",
  },
  itemController: {
    searchItems: "Items/SearchItems",
    getItemListToAddInTransaction: "GetItemListToAddInTransaction",
    getItemFullDetailsById: "GetItemFullDetailsById",
    getItemImageByItemId: "Items/GetItemImageByItemId?ItemId",
    getItemConfigurations: "Items/GetItemConfigurations",
    getItemsSimplifiedModel: "Transaction/GetItemsSimplifiedModel",
    getItemByItemInStoreId: "Items/GetItemByItemInstoreId",
    searchItemBalanceInventoryCheck:
      "InventoryCheck/SearchItemBalanceInventoryCheck",
    UpdateTaxPercentageOfCategory: "UpdateTaxPercentageOfCategory",
    saveItemFull: "SaveItemFull",
    deleteItem: "DeleteItem",
    saveInventoryChecking: "SaveInventoryChecking",
    getItemsForMoveBetweenStores:
      "MoveItemsTransaction/GetItemsForMoveBetweenStores",
    getItemUnitBalanceByItemUnitID: "GetItemUnitBalanceByItemUnitID",
  },
  itemReportController: {
    reportItemsData: "ItemsReport/ReportItemsData",
    reportBestLeastSellingItems: "ItemsReport/ReportBestLeastSellingItems",
    reportExpiryDateOfItems: "ItemsReport/ReportExpiryDateOfItems",
    reportEditUserItemData: "ItemsReport/ReportEditUserItemData",
    reportProductionItemsData: "ItemsReport/ReportProductionItemsData",
    reportItemsReachedToLimitOrder: "ItemsReport/ReportItemsReatchToLimitOrder",
    reportInventoryChecking: "ItemsReport/ReportInventoryChecking",
    reportStagnantItems: "ItemsReport/ReportStagnantItems",
    reportFollowItemBalance: "ItemsReport/ReportFolowItemBalance",
    reportSummeryItemTransaction: "ItemsReport/ReportSummeryItemTransacion",
    reportSummeryItemTransactionQuantityWithValue:
      "ItemsReport/ReportSummeryItemTransactionQuntityWithValue",
    reportSummeryItemTransactionQuantity:
      "ItemsReport/ReportSummeryItemTransactionQuntity",
    reportItemsDifferentInCost: "ItemsReport/ReportItemsDiffrentinCost",
  },
  lookupController: {
    getSortReportBestLeastSellingItems: "GetSortReportBestLeastSellingItems",
    getAllTransactionTypes: "GetAllTRasnactionTypes",
    getAllCountryIsoCode: "GetAllCountryIsoCode",
    getLookupsByTypeId: "GetLookupsByTypeId",
    getLookupByTypeId: "GetLookupByTypeId",
    getFilteredItemByZero: "CommonService/FiliterCompareToZero",
    getAllCalcType: "GetAllCalacType",
    getAllCostCenters: "GetAllCostCenters",
    saveLookup: "SaveLookup",
    deleteLookup: "DeleteLookup",
    getAllActionLogTypes: "LookupType/GetAllActionTypeLog",
    getAllAcTransactionTypes: "LookupType/GetAllAcTransactionTypes",
  },
  paymentTypeController: {
    getPaymentConfiguration: "PaymentType/GetPaymentConfiguration",
    getAllPaymentType: "PaymentType/GetAllPaymentType",
    getPaymentTypeById: "PaymentType/GetPaymentTypeById",
    savePaymentType: "PaymentType/SavePaymentType",
    deletePaymentType: "PaymentType/DeletePaymentType",
    getParentsOfPaymentType: "PaymentType/GetParentsOfPaymentType",
  },
  printerSetting: {
    getAllPrinters: "PrinterSettings/GetAllPrinters",
    saveTransactionPrintingSettings:
      "TransactionPrintingSetting/SaveTransactionPrintingSettings",
    getTransactionPrintingSettingsByUserId:
      "TransactionPrintingSetting/GetTransactionPrintingSettingsByUserId",
    getGroupPrinters: "TransactionPrintingSetting/GetGroupPrinters",
    updateGroupPrinters: "TransactionPrintingSetting/UpdateGroupPrinter",
  },
  restaurantTableController: {
    getAllRestaurantTables: "GetAllResturantTables",
    getAllMainParentRestaurantTable:
      "ResturantTable/GetAllMainParentResturantTable",
    getAllRestuarntTableByParentId:
      "ResturantTable/GetAllRestuarntTableByParentId",
    saveRestaurantTable: "ResturantTable/SaveResturantTable",
    deleteRestaurantTable: "ResturantTable/DeleteResturantTable",
    getReservedTransactionByTableId: "GetReservedTransactionByTableId",
  },
  storeController: {
    getStoreList: "GetStoreList",
    saveStore: "SaveStore",
    deleteStore: "DeleteStore",
  },
  supplierReportController: {
    reportSuppliersData: "SupplierReport/ReportSuppliersData",
    reportSuppliersPayments: "SupplierReport/ReportSuppliersPayments",
    reportSuppliersAccount: "CustomerReport/ReportSuppliersAccount",
    reportAllSuppliersTransaction:
      "CustomerReport/ReportAllSuppliersTransaction",
  },
  systemConfiguration: {
    getAllSystemLightModule: "SystemConfiguration/GetAllSystemLightModule",
  },
  systemSettingController: {
    getClientFeatures: "SystemConfiguration/GetClientFeatures",
  },
  transactionController: {
    validateTransactionEligibilityForPaymentUrl:
      "Transaction/ValidateTransactionEligibilityForPayment",
    validateEditTransactionUrl: "ValidateEditTransaction",
    validateDeleteTransactionUrl: "ValidateDeleteTransaction",
    validateReturnTransactionUrl: "ValidateReturnTransaction",
    searchTransactionUrl: "SearchTransaction",
    getTransactionForReturnByIdUrl: "Transaction/GetTransactionForReturnById",
    getFullTransactionByIdUrl: "Transactions/GetFullTrnsactionByID",
    getTransactionFullInfoByIdUrl: "GetTrnsactionFullInfoById",
    printTransactionReportPdf: "PrintTrasnactionReportPdf",
    deleteTransactionUrl: "DeleteTransaction",
    saveTransactionUrl: "Transactions/SaveTransactions",
    saveStoreTransferTransactionUrl:
      "MoveItemsTransaction/SaveTransactionMoveItemBetweenStore",
    searchStoreTransferTransactionUrl:
      "MoveItemsTransaction/SearchMoveItemBetweenStoresTransaction",
    printMoveItemsTransaction: "MoveItemsTransaction/PrintMoveItemsTransaction",
    cancelReservation: "CncelReservation",
    searchReservedTransactions:
      "/ReservedTrasnaction/SearchReservedTrasnaction",
    getReservedTransactionByID: "GetReservedTransactionByTransactionId",
    getTransactionAsSource: "Transaction/GetTrasnactionAsSource",
  },
  transactionDueDateController: {
    getAllTransactionsDueDate: "/TransactionDueDate/SearchTransactionDueDate",
    getTransactionDueDateById: "TransactionDueDate/GetTransactionDueDateById",
    saveTransactionDueDate: "TransactionDueDate/SaveTransactionDueDates",
  },
  transactionReportController: {
    reportItemsDifferentInVatCalculation:
      "Transactions/ReportItemsDiffrentInVatCalculation",
    reportStations: "Transactions/ReportStations",
    reportOrderStatusLog: "Transactions/ReportOrderStatusLog",
    reportSalesInGraph: "ReportGraph/ReportSalesInGraph",
    reportProfitSalesInGraph: "ReportGraph/ReportProfitSalesInGraph",
    salesTransactionsReport: "Transactions/SalesTransactionsReport",
    returnSalesTransactionsReport: "Transactions/ReturnSalesTransactionsReport",
    allSalesAndReturnTransactionsReport:
      "Transactions/AllSalesAndReturnTransactionsReport",
    purchaseTransactionsReport: "Transactions/PurchaseTransactionsReport",
    returnPurchaseTransactionsReport:
      "Transactions/ReturnPurchaseTransactionsReport",
    reportCashier: "Transactions/ReportCashier",
    reportEmployeeSales: "Transactions/ReportEmplyeeSales",
    reportProfitOfSales: "Transactions/ReportProfitOfSales",
    reportVat: "Transactions/ReportVat",
    reportAcTransactionsUserLogs: "Transactions/ReportVat",
    reportUserTransactionLog: "TransactionsReport/ReportLogUserTransaction",
  },
  treasuryReportController: {
    reportInMoney: "TreasuryReport/ReportInMoney",
    reportOutMoney: "TreasuryReport/ReportOutMoney",
    reportInAndOutMoney: "TreasuryReport/ReportInAndOutMoney",
    reportAllInAndOutMoney: "TreasuryReport/ReportAllInAndOutMoney",
  },
  unitController: {
    getUnitList: "GetUnitList",
    saveUnit: "SaveUnit",
    deleteUnit: "DeleteUnit",
  },
  userController: {
    validateLogin: "User/ValidateLogin",
    getUsersList: "GetUsersList",
    logoutUser: "User/Logout",
    getUserById: "GetUserById",
    changeUserLanguage: "User/ChangeLanguage",
    getUserPermission: "GetUserPermission",
    getUserStorePermission: "User/GetUserStorePermissions",
    getUserBranchPermission: "User/GetBranchesUserPermissions",
    getUserSettings: "GetUserSettings",
    loadMenuByUserId: "LoadMenuByUserId",
    getUserPosSettings: "UserSettings/GetUserPosSettings",
    getUserPOSPermission: "GetUserPOSPermission",
    getTransactionSettings: "GetTransactionSettings",
    getUserTransactionsSettings: "User/GetUserTransactionsSettings",
    getUserDashboardSummary: "User/DashBoardSummery",
    getUserAlert: "User/GetUserAlert",
    saveUserSettingsUrl: "SaveUserSettings",
    deleteUser: "DeleteUser",
    saveUser: "SaveUser",
    saveUserPermissions: "SaveUserPermissions",
    saveUserStorePermissions: "User/SaveUserStorePermissions",
    saveUserBranchPermissions: "User/SaveUserBranchesPermissions",
    saveUserSettings: "SaveUserSettings",
    saveTransactionSettings: "SaveTransactionSettings",
    saveUserPosSettings: "UserSettings/SaveUserPosSettings",
    getUserBranchPermissions: "User/GetUserBranchPermmissions",
  },
  voucherController: {
    getVoucherByCode: "Voucher/GetVocherByCode",
  },
};
